import classNames from 'classnames';
import React from 'react';

import { formatNumber } from '../utils/number';

import './StatsTable.css';

export default ({ rows, showZeros = false }) => (
  <table className="StatsTable">
    <tbody>
      {rows.map(({name, value, spaceAfter}) => showZeros || value ? (
        <tr
          key={name}
          className={classNames('StatsTable__row', {
            'StatsTable__row--space-after': spaceAfter,
          })}
        >
          <td className="StatsTable__cell">{name}</td>
          <td className="StatsTable__cell">{ typeof value === 'number' ? formatNumber(value) : value}</td>
        </tr>
      ) : null)}
    </tbody>
  </table>
);




// WEBPACK FOOTER //
// ./src/components/StatsTable.js